<template>
  <div>
    <div class="input-group-prepend">
      <span class="input-group-text"><i class="fa fa-search"></i></span>
    </div>
    <input v-bind:class="stylingClasses" v-on:input="googleSearch()" v-on:keydown.enter="dataSelected()" type="text" v-model="searchTerm" v-bind:placeholder="placeholder"/>
    <div id="attribution-node"></div>
    <div class="suggestions-container">
      <ul class="suggestion-list">
        <li class="suggestion" v-for="datum in modifiedResults" v-bind:key="datum.id" v-on:click="dataSelected(datum)">
          <img v-if="(datum.photos && datum.photos.length) || datum.icon" class="suggestion-thumbnail" v-bind:src="(datum.photos && datum.photos.length ? datum.photos[0].getUrl() : datum.icon)">
          <span v-if="(datum.photos && datum.photos.length) || datum.icon"> </span>
          <span class="suggestion-name">{{ datum.name }}</span>
          <span class="suggestion-location"> {{ datum.formatted_address }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import GooglePlacesApi from '../../../lib/googlePlacesApi.js'

export default {
  data () {
    return {
      maximumNumberSuggestions: 10,
      results: [],
      searchTerm: this.initialSearchTerm
    }
  },
  computed: {
    modifiedResults () {
      return this.results.slice(0, this.maximumNumberSuggestions)
    }
  },
  methods: {
    async googleSearch () {
      try {
        if (!this.searchTerm.length) this.results = []
        let node = document.getElementById('attribution-node')
        let area = await GooglePlacesApi.getUsersBestGuessPostalCode()
        this.results = await GooglePlacesApi.googleSearch(node, this.searchTerm, area)
      } catch (error) {
        console.log(error)
      }
    },
    dataSelected (datum) {
      if (datum) {
        this.searchTerm = datum.name
        this.$emit('suggestionSelected', datum)
      } else {
        this.$emit('suggestionSelected', this.searchTerm)
      }
      this.results = []
    }
  },
  props: {
    initialSearchTerm: {
      type: String,
      default: ''
    },
    searchIcon: {
      type: Boolean,
      default: true
    },
    stylingClasses: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.suggestion {
  background: white;
  list-style-type: none;
}

.suggestion:hover {
  background-color: rgb(254, 237, 170);
  cursor: pointer;
}

.suggestions-container {
  padding-left: 2px;
  position: absolute;
  top: 37px;
  z-index: 2;
}

.suggestion-list {
}

.suggestion-location {
  font-size: 0.8rem;
}

.suggestion-name {
  font-weight: bold;
}

.suggestion-thumbnail {
  height: 25px;
  width: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/general/inputs/GoogleTextSearch.vue